import { faFolderOpen, faSave } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { useAppSelector } from "../../app/hooks";
import { setState, store } from "../../app/store";
import { useTranslations } from "../i18n";
import "./buttons.css"
import { getMetadata } from "meta-png";

export function SaveButton() {
    const [download, setDownload] = React.useState(false);
    const t = useTranslations();

    return <div className="icon-button save-button" onClick={() => setDownload(true)} title={t.save}>
        <FontAwesomeIcon icon={faSave} />
        {download && <DownloadComponent onDownload={() => setDownload(false)} />}
    </div>
}

export const sanitizeName = (name: string): string => name
    .replaceAll(/\W/g, "-")
    .replaceAll(/--+/g, "-")
    .substring(0, 20)
    .replaceAll(/(^-+|-+$)/g, "");

function DownloadComponent(props: { onDownload: () => void }) {
    const wholeState = useAppSelector(state => state);
    const dataUrl = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(wholeState));
    const downloadName = `Argumentationswippe-${sanitizeName(wholeState.titles.title)}.json`;

    return <a
        href={dataUrl}
        download={downloadName}
        ref={x => {
            x?.click();
            props.onDownload();
        }}
        style={{ display: "none" }}
    >
        dummy
    </a>
}

export function LoadButton() {
    const fileDialogRef = React.useRef<HTMLInputElement>(null);
    const t = useTranslations();

    return <div className="icon-button load-button" onClick={() => fileDialogRef.current?.click()} title={t.load}>
        <FontAwesomeIcon icon={faFolderOpen} />
        <input type="file" style={{ display: "none" }} ref={fileDialogRef} onChange={async e => {
            const file = e.target.files?.item(0);
            if (!file) {
                alert("No file selected.");
                return;
            }
            await loadFile(file);
        }} accept=".json,application/json,.png,image/png" />
    </div>
}

const getJsonDataFromFile = async (file: File): Promise<string | null> => {
    if (file.type.startsWith("image/png")) {
        // try to extract JSON from PNG metadata
        const arrayBuffer = await file.arrayBuffer();
        const uint8Array = new Uint8Array(arrayBuffer);
        const json = getMetadata(uint8Array, "argumentationswippe");
        if (!json) {
            alert("Cannot load this PNG file -- looks like it does not contain the required metadata. Has it been exported from this app?");
            return null;
        };
        return json;
    } else {
        return await file.text();
    }
}


export const loadFile = async (file: File): Promise<void> => {
    const json = await getJsonDataFromFile(file);
    if (!json) return;

    const data = JSON.parse(json);
    store.dispatch(setState(data));
}
